export default __webpack_public_path__ + "static/media/landing-desktop-placeholder.1ef6f8f9.jpg";